module.exports = __webpack_public_path__ + "static/media/doctor-avetar-ash.e75e1168.png";